import { render } from "./Divorce.vue?vue&type=template&id=72d82665"
import script from "./Divorce.vue?vue&type=script&lang=js"
export * from "./Divorce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__